import React from "react";
import { getHighlightSegments } from "../helpers/globalSearchHelper";
import "../styles/SearchHighlight.css";

// Wraps the parts of `text` that match `query` in <mark>.
const SearchHighlight = ({ text, query, enabled = true }) => {
  if (!enabled || !query) return text;
  return getHighlightSegments(text, query).map((segment, index) =>
    segment.match ? (
      <mark key={index} className="search-highlight-mark">{segment.text}</mark>
    ) : (
      <React.Fragment key={index}>{segment.text}</React.Fragment>
    ));
};

export default SearchHighlight;
